module.exports = __webpack_public_path__ + "img/electric_use_selected.2a17c45a.svg";